import React from 'react'

const Week = ({
    children
}) => {
    return (
        <div style={{ display: 'flex', alignContent: 'center', justifyContent: 'space-between'}}>
            {children}
        </div>
    )
}

export default Week